import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../../services/api";
import PopupRenderer from "./PopupRenderer";
import "./PopupManager.css";


function PopupManager() {

  console.log("PopupManager chargé");

  const location = useLocation();

  const [popup, setPopup] = useState(null);

  const token = localStorage.getItem("token");

  const user = JSON.parse(
    localStorage.getItem("user") || "null"
  );

  const canShowPopup = (popup) => {

    if (!popup) return false;

    switch (popup.audience) {

      case "all":
        return true;

      case "guest":
        return !token;

      case "logged":
        return !!token;

      case "vip":
        return user?.isVip;

      case "non_vip":
        return token && !user?.isVip;

      case "admin":
        return user?.role === "admin";

      default:
        return false;
    }
  };

  const loadPopup = async () => {

    try {

      const res =
  await API.get("/popups/active");

const popupData =
  res.data;

if (!popupData) return;

const intervalKey =
  `popup_last_${popupData._id}`;

const lastView =
  localStorage.getItem(intervalKey);

if (lastView) {

  const diffMinutes =

    (Date.now() - Number(lastView))
    / 1000 / 60;

  if (
    diffMinutes <
    popupData.intervalMinutes
  ) {

    return;

  }

}

setPopup(popupData);

    }

    catch (error) {

      console.log(error);

    }

  };

  useEffect(() => {

  loadPopup();

  const interval = setInterval(() => {

    loadPopup();

  }, 30000);

  return () => clearInterval(interval);

}, []);

  // Auto fermeture
  useEffect(() => {

    if (
      popup?.autoCloseMinutes > 0
    ) {

      const timer = setTimeout(
        () => {

          setPopup(null);

        },
        popup.autoCloseMinutes *
        60 *
        1000
      );

      return () =>
        clearTimeout(timer);

    }

  }, [popup]);

  // LocalStorage
  useEffect(() => {

  if (!popup) return;

  const intervalKey =
    `popup_last_${popup._id}`;

  localStorage.setItem(
    intervalKey,
    Date.now()
  );

}, [popup]);

  // Pas encore chargé
  if (!popup) {

    console.log(
      "Aucun popup chargé"
    );

    return null;

  }

  // Audience
  if (!canShowPopup(popup)) {

    console.log(
      "Audience refusée"
    );

    return null;

  }

  // Pages autorisées
  if (
    popup.pages &&
    !popup.pages.includes("all") &&
    !popup.pages.includes(
      location.pathname
    )
  ) {

    console.log(
      "Page refusée :",
      location.pathname
    );

    return null;

  }

  const storageKey =
    `popup_views_${popup._id}`;

  const currentViews =
    Number(
      localStorage.getItem(
        storageKey
      ) || 0
    );

  console.log(
    "Views :",
    currentViews
  );

  console.log(
    "Popup affiché :",
    popup
  );

  // TEMPORAIRE :
  // on désactive le blocage maxViews
  /*
  if (
    currentViews >=
    popup.maxViews
  ) {
    return null;
  }
  */

return (

    <div
    style={{
      position: "fixed",
      top: "0",
      left: "0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "rgba(0,0,0,0.75)",
      height: "100%",
      width: "100%",
      color: "#fff",
      padding: "20px",
      zIndex: 99999,
   
    }}
  >
  <div
   className="popup-carte"
  >

    <button
      onClick={() => setPopup(null)}
      style={{
        position: "absolute",
        top: "8px",
        right: "8px",
        background: "transparent",
        border: "none",
        color:  "var(--white)",
        fontSize: "20px",
        cursor: "pointer"
      }}
    >
      ✕
    </button>

    <h3  
     style={{

      textAlign: "center",

   
    }}>
      {popup.title}
    </h3>

     <PopupRenderer
        popup={popup}
      />

  </div>

  </div>

);

}

export default PopupManager;  
    